var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M6.278.503l-5.65 5.66a1 1 0 101.41 1.42l5-4.95 4.95 4.95a1 1 0 001.41 0 1 1 0 00.3-.71.999.999 0 00-.3-.71L7.748.503a1 1 0 00-1.47 0z"}})}
var staticRenderFns = []

export { render, staticRenderFns }